<template>
	<PageCrumbHeaderLayout class="page-crumb-header"
		:crumbs="crumbs"
		:disabled="disabled"
		v-on="bubble( `back`, `crumb` )"
	>
		<template #title>
			<span class="title" v-html="title"></span>
		</template>
	</PageCrumbHeaderLayout>
</template>

<script>
import EventsMixin from "../mixins/EventsMixin";
import PageCrumbHeaderLayout from "./PageCrumbHeaderLayout.vue";
export default {
	name: "PageCrumbHeader",
	mixins: [ EventsMixin, ],
	emits: [ "back", "crumb", ],
	components: {
		PageCrumbHeaderLayout,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			required: true,
		},
		/** [ { text:String, route:String, isActive:Boolean, }, ... ] */
		crumbs: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.page-crumb-header {
	@include anchor() {
		color: $anchorColor !important;
		font-weight: 600;
		text-decoration: none;
	}
}
</style>
